
export const Separator = () => (
  <div className="w-full border-t border-slate-200 my-5" />
)